import { render } from "./AppTabs.vue?vue&type=template&id=3b2c0b2f&ts=true"
import script from "./AppTabs.vue?vue&type=script&lang=ts"
export * from "./AppTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__